import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            console.log(err);
            const isAuthEndpoint = request.url.includes('/auth-login') || request.url.includes('/login') || request.url.includes('/auto-login');
            const errMsg = (err.error?.message || err.error?.error || err.message || '').toString().toLowerCase();

            if (!isAuthEndpoint && ([401, 403].includes(err.status) || errMsg.includes('suspended') || errMsg.includes('inactive') || errMsg.includes('access denied'))) {
                localStorage.clear();
                sessionStorage.clear();
                this.authenticationService.logout();
                if (window.location.pathname !== '/') {
                  window.location.href = '/';
                }
            }
            return throwError(err);
        }))
    }
}